/**
 * Common button component
 *
 * Properties:
 *
 *      link:       string, href-html-attribute
 *      beautify:   boolean, draw button with colorful gradient (optional)
 *      round:      boolean, draw button with rounded corners (optional)
 *      icon:       string, class name of button icon
 *      title:      string, inner button label
 *      name:       string, name of button is attribute in handler
 *      handler:    function, callback to trigger if link is #
 */

//@ts-nocheck

import React from "react";
import Biscuit from "../../utils/Biscuit";
import t from "../helpers/t";

const LargeButton: (props: any) => React.JSX.Element = (props: any): React.JSX.Element => {
  let _class: string =
    typeof props.beautify && props.beautify === true
      ? "button beautify beautify-" + Biscuit.get("user.client_id")
      : "button";

  if (typeof props.round !== "undefined" && props.round === true) _class += " round";
  // @ts-ignore
  return (
    <>
      {typeof props.inputType !== "undefined" ? (
        <>
          <label htmlFor="upload-file-input" style={{ fontSize: ".85rem", fontWeight: "normal" }}>
            <a>
              {/* Left the href = "#" out by purpose: fileInput wouldn't get called */}
              <i className="fi fi-page-add entity-icon"></i>+ {t("add_${a}", { a: t("document") })}
            </a>
          </label>
          <input
            id="upload-file-input"
            name="upload-file-input"
            type="file"
            style={{ position: "fixed", top: "-100em" }}
            onChange={(e) => props.handler(e)}
          />
        </>
      ) : (
        <>
          {typeof props.type !== "undefined" && (
            <>
              <a
                href={props.link}
                name={props.name}
                onClick={
                  props.link === "#"
                    ? (e: React.MouseEvent<HTMLAnchorElement>) => {
                        props.handler(e);
                      }
                    : (): void => {}
                }
              >
                <button className={_class} title={props.title} name={props.name}>
                  <span id={props.name} className="hide">
                    <img className="rollingLoader" src="assets/img/rolling_loader.svg" />
                  </span>
                  <i className={props.icon}> </i>
                  <span>{props.title}</span>
                </button>
              </a>
            </>
          )}
          {typeof props.type === "undefined" && (
            <>
              <a
                href={props.link}
                name={props.name}
                onClick={
                  props.link === "#"
                    ? (e: React.MouseEvent<HTMLAnchorElement>): void => {
                        props.handler(e);
                      }
                    : () => {}
                }
                className={_class}
                title={props.title}
              >
                <span id={props.name} className="roll hide">
                  <img className="rollingLoader" src="assets/img/rolling_loader.svg" />
                </span>
                <i className={props.icon}> </i>
                <span>{props.title}</span>
              </a>
            </>
          )}
        </>
      )}
    </>
  );
};
export default LargeButton;
